import { ajaxController } from "./controller/AjaxController";
import { PatternDesignDTO, PatternDetailDTO, PatternDiggingDTO, PatternMoveRequest, PatternMoveResultDTO } from "../DTOs/DrillBlast/PatternLifecycleDTO";

class BlastPatternAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/BlastPattern";

  public getPattern(patternBlastId: number) {
    return this._ajaxController.get<PatternDetailDTO>(`${this._endpoint}/${patternBlastId}`, {});
  }

  public saveDesign(patternBlastId: number, design: PatternDesignDTO) {
    return this._ajaxController.put<PatternDesignDTO, PatternDetailDTO>(`${this._endpoint}/${patternBlastId}/design`, design);
  }

  public move(patternBlastId: number, request: PatternMoveRequest) {
    return this._ajaxController.post<PatternMoveRequest, PatternMoveResultDTO>(`${this._endpoint}/${patternBlastId}/status`, request);
  }

  public getDigging(patternBlastId: number) {
    return this._ajaxController.get<PatternDiggingDTO>(`${this._endpoint}/${patternBlastId}/digging`, {});
  }

  public getBlastRecord(patternBlastId: number) {
    return this._ajaxController.get<string>(`${this._endpoint}/${patternBlastId}/blast-record`, {});
  }

  public downloadBlastRecord(patternBlastId: number, reference: string) {
    return this._ajaxController.downloadFile(`${this._endpoint}/${patternBlastId}/blast-record/pdf`, `BlastRecord_${reference}.pdf`);
  }
}

export const blastPatternAjax = new BlastPatternAjax();
